(function () {
    'use strict';

    angular
        .module('app')
        .factory('EntityFieldScalar', EntityFieldScalarFactory);

    EntityFieldScalarFactory.$inject = [];

    function EntityFieldScalarFactory() {

        /**
         * @constructor
         * @name EntityFieldScalar
         */
        function EntityFieldScalar(name, value) {
            this.name = name;
            this.value = value;
            this.fieldInfo = {
                mandatory: false
            };
        }

        EntityFieldScalar.prototype.toString = function () {
            return this.value;
        };

        return EntityFieldScalar;
    }
})();